// extracted by mini-css-extract-plugin
module.exports = {"root":"BrowsingLevelsGrouped_root__BWKRZ","label":"BrowsingLevelsGrouped_label__6L_nK","iconWrapper":"BrowsingLevelsGrouped_iconWrapper__jWpfU"};